import React from "react";
import classes from "./Banner.module.css";
import ButtonComp from "../ButtonComp";

export default function Banner() {
  return (
    <section className={classes.banner}>
      <img
        src="/img/home-img/home-banner-1.jpg"
        className={classes.bgImage}
        alt="banner image"
      />

      <div className={classes.content}>
        <h1 className={classes.heading}>
          Reliable <span>Servers</span> & <span>Networking</span> for Your{" "}
          <span>Business</span>
        </h1>

        <p className={classes.text}>
          Discover top-quality IT hardware solutions at unbeatable prices. From
          high-performance servers and custom-built PCs to routers, switches,
          and components — TechMatter is your trusted partner for business-grade
          technology across the UK and Europe.
        </p>

        <ButtonComp
          link="/shop"
          text="Explore Products"
          customStyleClass={classes.homeBannerBtn}
        />
      </div>
    </section>
  );
}
